import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { MarkerPopupComponent } from '../marker-popup/marker-popup.component';
import { MarkerPopupDirective } from '../../utils/marker-popup.directive';
import { SearchLocationService } from '../../services/search-location.service';

@NgModule({
    imports: [IonicModule],
    providers: [SearchLocationService],
    declarations: [MarkerPopupComponent, MarkerPopupDirective],
    exports: [MarkerPopupComponent, MarkerPopupDirective]
})
export class LeafletCustomContextMenuModule {}
